module.exports = __webpack_public_path__ + "dist/assets/img/V.74632cc6.svg";